export function formatCurrencyFormat(price: string, format: string) {
    return format.replace("{price}", price);
}
